import {createSelector, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {apiSlice} from "../../../app/apiSlice";
import {AdminSearchCriteria} from "./AdminSearchCriteria";
import {getStorageItem} from "../../../persistence";
import {Role} from "../../user/Admin";
import {RootState} from "../../../app/store";

interface UserManagementState {
    criteria: AdminSearchCriteria;
    roles: Role[];
}

export const STORAGE_KEY_USER_MANAGEMENT_CRITERIA = 'admin-search-criteria';

const initialState: UserManagementState = {
    criteria: getStorageItem(STORAGE_KEY_USER_MANAGEMENT_CRITERIA, {}),
    roles: []
};

const slice = createSlice({
    name: 'userManagement',
    initialState: initialState,
    reducers: {
        saveAdminSearchCriteria: (state, {payload}: PayloadAction<AdminSearchCriteria>) => {
            state.criteria = payload;
        },
        resetAdminSearchCriteria: (state) => {
            state.criteria = {
                roles: getDefaultRolesCriteria(state.roles)
            }
        }
    },
    extraReducers: builder => {
        builder.addMatcher(
            apiSlice.endpoints.getRoles.matchFulfilled,
            (state, {payload: roles}) => {
                state.roles = roles;
                if (!state.criteria.roles) {
                    state.criteria.roles = getDefaultRolesCriteria(roles);
                }
            }
        );
    }
});

export default slice;

export const selectAdminSearchCriteria = createSelector(
    [state => {
        return state.userManagement.criteria;
    }],
    (criteria) => {
        return criteria;
    },
);

export const selectAdminRoles = createSelector([
        (s: RootState) => s.userManagement.roles
    ],
    roles => roles
);

export const {
    saveAdminSearchCriteria,    
    resetAdminSearchCriteria
} = slice.actions;

function getDefaultRolesCriteria(roles: Role[]): number[] {
    return roles.map(r => r.id);
}
